import authUserService from "@/services/auth-user.service";
import http from "@/http";
import { setCookie, getCookie } from "@/utils/cookies";

function getTabId() {
  let tabId = sessionStorage.getItem("tabId");

  if (!tabId) {
    tabId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    sessionStorage.setItem("tabId", tabId);
  }

  window.tabId = tabId;
  return tabId;
}

const PUBLIC_ROUTE_NAMES = [
  "login",
  "splash",
  "not-found",
  "not-found-redirect",
  "sso-callback",
  "account-deactivate",
  "why-scio",
  "contact",
  "docs",
];

const AUTH_LANDING_ROUTE_NAMES = [
  "login",
  "splash",
];

function isPublicRoute(to) {
  return PUBLIC_ROUTE_NAMES.includes(to.name) || to.meta?.layout === "public";
}

function isMeaningfulLastPath(path) {
  return path && path !== "/" && path !== "/login/";
}

export function setupRouteGuards(router) {
  router.afterEach((to) => {
    if (!authUserService.isAuthenticated()) return;

    const isAuthRoute = PUBLIC_ROUTE_NAMES.includes(to.name);

    if (!isAuthRoute) {
      setCookie("lastPath", to.fullPath, 7);

      const tabId = getTabId();
      let tabPaths;

      try {
        tabPaths = JSON.parse(getCookie("tabPaths") || "{}");
      } catch {
        tabPaths = {};
      }

      tabPaths[tabId] = to.fullPath;
      setCookie("tabPaths", JSON.stringify(tabPaths), 7);
    }
  });

  router.beforeEach(async (to, from, next) => {
    if (!isPublicRoute(to)) {
      if (!authUserService.isAuthenticated()) {
        await authUserService.initFromCookie();
      }

      if (!authUserService.isAuthenticated()) {
        return next({
          name: "login",
          query: { redirect: to.fullPath },
        });
      }
    }

    if (to.meta?.requiresProjectAdmin) {
      const projectId = Number(to.params?.id || to.params?.projectId || 0);
      if (!projectId) return next({ name: "project-list" });

      try {
        await http.get(`/api/v2/projects/${projectId}/management-access`);
      } catch {
        return next({ name: "project-workspace", params: { id: projectId }, replace: true });
      }
    }

    if (
      authUserService.isAuthenticated() &&
      AUTH_LANDING_ROUTE_NAMES.includes(to.name)
    ) {
      const lastPath = getCookie("lastPath");

      if (isMeaningfulLastPath(lastPath)) {
        return next({ path: lastPath, replace: true });
      }

      return next({ name: "project-list" });
    }

    if (to.meta?.requiresAdmin && String(authUserService.getUserRole() || "").toUpperCase() !== "ADMIN") {
      return next({ name: "project-list", replace: true });
    }

    return next();
  });
}
